import { theme } from '@policygenius/mortar';

export const isMobileSize = (): boolean => window.innerWidth < theme.breakpoints.medium;
export const isDesktopSize = (): boolean => window.innerWidth >= theme.breakpoints.large;
